import KlarnaContainer from './KlarnaContainer';

export default KlarnaContainer;
